import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Form, Formik, Field } from "formik";
import FormInput2 from "../../components/FormInput/FormInput2";
import { Link } from "react-router-dom";
import Nibss from "../../assets/assets/Nibss-Logo.png";
import Loader from "../../components/Loader/Loader";
import Button from "../../components/Button/Button";
import EmailModal from "../../components/EmailModal/EmailModal";
import Mail from "../../assets/assets/mail.svg";
import { ResetSchema } from "../../utils/validation";
import { sendNewPassword } from "../../redux/Actions/PasswordActions";
import { reVerifyEmail } from "../../redux/Actions/SingleUserActions";
import { PropTypes } from "prop-types";

const SendNewPassword = (props) => {
  const { sendNewPassword, isLoading, newPasswordSuccess } = props;

  const [state, setState] = useState({
    hide: true,
    hidden: true,
    openModal: false,
  });

  const handleClick = () => {
    setState({
      ...state,
      hide: !state.hide,
    });
  };

  const handleClick2 = () => {
    setState({
      ...state,
      hidden: !state.hidden,
    });
  };

  const hide = () => {
    setState({
      ...state,
      openModal: false,
    });
  };

  const submitData = (value) => {
    const newValue = {
      code: value.code.toString(),
      password: value.password,
    };
    sendNewPassword(newValue);
  };

  useEffect(
    () => {
      if (newPasswordSuccess) {
        setState({
          ...state,
          openModal: true,
        });
        document.getElementById("form").reset();
      }
    },
    // eslint-disable-next-line
    [newPasswordSuccess]
  );

  return (
    <div className="reset-password-wrap">
      <Link to="/">
        <div className="reset-password-logo">
          <img src={Nibss} alt="nibss-logo" />
        </div>
      </Link>
      <div className="reset-password-body">
        <div className="reset-password-form-container">
          <div className="reset-password-text">
            <div className="reset-password-text-header">Password Recovery</div>
            <div className="reset-password-text-body">
              Enter the verification code sent to your mail, and your new
              password
            </div>
          </div>

          {newPasswordSuccess && (
            <EmailModal show={state.openModal} hide={hide}>
              <div className="enter-portal">
                <div className="success-logo">
                  <img src={Mail} alt="mail" />
                </div>

                <div className="enter-portal-content">
                  <h1>Your password reset was successful</h1>
                  <p>You can now Login with your new password</p>
                  <Link to="/login">
                    <button>
                      Login &nbsp; &nbsp;
                      {isLoading ? <Loader /> : ""}
                    </button>
                  </Link>
                </div>
              </div>
            </EmailModal>
          )}

          <div className="reset-password-form-body">
            <Formik
              initialValues={{
                email: "",
              }}
              onSubmit={(values) => {
                submitData(values);
              }}
              validationSchema={ResetSchema}
            >
              {({ handleSubmit, isValid, dirty }) => {
                return (
                  <Form id="form">
                    <div className="reset-password-form-wrap">
                      <div className="form-input">
                        <div className="form-input">
                          <Field
                            name="code"
                            label="Password Reset Code"
                            placeholder="Input Code"
                            type="number"
                            component={FormInput2}
                          />
                        </div>

                        <div className="form-input-password">
                          <span id="show" onClick={handleClick}>
                            {state.hide ? "SHOW" : "HIDE"}
                          </span>
                          <Field
                            name="password"
                            label="New Password"
                            placeholder="Enter Password"
                            type={state.hide ? "password" : "text"}
                            component={FormInput2}
                          />
                        </div>
                        <div className="form-input-password">
                          <span id="show" onClick={handleClick2}>
                            {state.hidden ? "SHOW" : "HIDE"}
                          </span>
                          <Field
                            name="confirm_password"
                            label="Confirm Password"
                            placeholder="Confirm Password"
                            type={state.hidden ? "password" : "text"}
                            component={FormInput2}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="reset-button">
                      <Button
                        word={"SEND"}
                        width="100%"
                        disabled={!(isValid && dirty)}
                        img={isLoading ? <Loader /> : ""}
                      />
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  sendNewPassword: (password) => dispatch(sendNewPassword(password)),
  reVerifyEmail: (payload) => dispatch(reVerifyEmail(payload)),
});

const mapStateToProps = (state) => ({
  reVerifying: state.singleUser.reVerifying,
  reVerifiedEmail: state.singleUser.reVerifiedEmail,
  isLoading: state.password.isSendingNewPassword,
  newPasswordSuccess: state.password.newPasswordSuccess,
});

SendNewPassword.propTypes = {
  sendNewPassword: PropTypes.func,
  isLoading: PropTypes.bool,
  newPasswordSuccess: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(SendNewPassword);
